import type { TrackPlugin, Tracker } from '../../core';

export interface ClickCaptureOptions {
  attributeName?: string;
  defaultEventName?: string;
}

/**
 * 浏览器端 DOM 元素点击自动捕获插件
 */
export function browserClickCapturePlugin(options?: ClickCaptureOptions): TrackPlugin {
  const attrName = options?.attributeName ?? 'data-track-click';
  const defaultEvent = options?.defaultEventName ?? 'element_click';

  return {
    name: 'hss-browser-click-capture-plugin',

    init(tracker: Tracker) {
      if (typeof document === 'undefined') return;

      document.addEventListener('click', (event: MouseEvent) => {
        try {
          const target = event.target as HTMLElement | null;
          if (!target) return;

          const trackEl = target.closest(`[${attrName}]`) as HTMLElement | null;
          if (!trackEl) return;

          const eventName = trackEl.getAttribute(attrName) || defaultEvent;
          const rawProps = trackEl.getAttribute('data-track-props');

          let parsedProps: Record<string, any> = {};
          if (rawProps) {
            try {
              parsedProps = JSON.parse(rawProps);
            } catch {
              parsedProps = { rawValue: rawProps };
            }
          }

          tracker.track(eventName, {
            elementTagName: trackEl.tagName.toLowerCase(),
            elementId: trackEl.id || undefined,
            elementClassName: trackEl.className || undefined,
            innerText: trackEl.innerText?.slice(0, 100),
            ...parsedProps,
          });
        } catch {
          // DOM 读取或宿主事件对象异常不外溢。
        }
      }, true);
    },
  };
}
